import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import { InfoFontIcon } from '../../components/CustomIcons';
import CustomSection from "../../components/CustomSection";
import SupportRequestTableView from "./SupportRequestTableView";
import CustomTabs from '../../components/CustomTabs';

const useStyles = makeStyles((theme) => ({
}));


export default function SupportRequestView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const { active, onChangeTab, serviceRequestsCompleted, serviceRequests } = props;
    console.log("serviceRequests==", serviceRequests);
    console.log("serviceRequestsCompleted==", serviceRequestsCompleted);

    const itemsTab = [
        {
            value: 'pending',
            label: 'Pending',
            count: serviceRequests ? serviceRequests.length : 0
        },
        {
            value: 'completed',
            label: 'Completed',
            count: serviceRequestsCompleted ? serviceRequestsCompleted.length : 0
        },
    ];
    return (
        <CustomSection notMarginTop={true} 
            title={t('support_request_title')} 
            icon={<InfoFontIcon style={{
                color: theme.palette.common.white,
            }}/>}
            customClass={classes.customClass}
            actionRight={{
                show: true,
                title: t('btn_create'),
                action: () => props.onAddSupportRequest()
            }}
        >
            {/* <CustomTabs 
                active={active}
                items={itemsTab}
                showCount={true}
                onChangeTab={onChangeTab}
            />
            <SupportRequestTableView rows={active == 'pending' ? serviceRequests : serviceRequestsCompleted}/> */}
            <SupportRequestTableView rows={serviceRequests}/>
        </CustomSection>
    );
}
